module.exports = __webpack_public_path__ + "img/DE03940.dcf77405.png";